import type { RemoteConfigPanelProps } from '@highimpact-front/remote-widget-core';
import type { JSONSerializable } from '@highimpact-frontend/api-types';

import { useDashboardHost } from '../../context/DashboardHostContext';
import { buildRemoteManifestUrl } from '../../internal/remote/buildRemoteManifestUrl';
import {
  isRemoteWidgetAwaitingConfiguration,
  stripAwaitingConfigurationProperty,
} from '../../state/dashboard-element-operations';

function RemoteConfigPanel(props: RemoteConfigPanelProps) {
  const { renderRemoteWidget } = useDashboardHost();
  const remoteUrl = buildRemoteManifestUrl(
    props.widget.props.url,
    props.widget.props.specificWidgetType
  );

  const additionalProps = props.widget.props.additionalProps;
  const sanitizedAdditionalProps = isRemoteWidgetAwaitingConfiguration(
    additionalProps
  )
    ? undefined
    : ((stripAwaitingConfigurationProperty(additionalProps) ?? undefined) as
        | Record<string, JSONSerializable>
        | undefined);

  const panelProps: RemoteConfigPanelProps =
    sanitizedAdditionalProps !== additionalProps
      ? {
          ...props,
          widget: {
            ...props.widget,
            props: {
              ...props.widget.props,
              additionalProps: sanitizedAdditionalProps,
            },
          },
        }
      : props;

  return (
    <>
      {renderRemoteWidget({
        remoteName: props.widget.props.specificWidgetType,
        remoteUrl,
        moduleName: 'ConfigPanel',
        props: panelProps,
      })}
    </>
  );
}

export default RemoteConfigPanel;
